<template>
	<NoLineBreaks>
		<InputDecimal
			v-model="connectionLimitNearVrs"
			:style="{ width: 'calc(100% - 25px)' }"
			:allowPoint="false"
			:showTooltipOnFocus="true"
			:toolTipText="$t('settings.profileManagement.tableColumns.connectionLimitNearVrsTooltip')"
			range="non-negative"
			:disabled="record.currentUser || !record.enabled"
			@keyup.enter="profileUpdateLocal()"
		/>
		<Button
			v-if="!record.currentUser && record.enabled"
			type="text"
			:style="{ height: '30px', color: grayDark }"
			@click="profileUpdateLocal()"
		>
			<template #icon>
				<CheckOutlined v-if="state === 'success'" :style="{ color: successColor }" />
				<LoadingOutlined v-else-if="state === 'loading'" />
				<EnterOutlined v-else />
			</template>
		</Button>
	</NoLineBreaks>
</template>


<script>
import { ref, toRef, watch } from 'vue';
import { Button } from 'ant-design-vue';
import { CheckOutlined, LoadingOutlined, EnterOutlined } from '@ant-design/icons-vue';

import Consts from '@/api/Consts';

import { useProfileUpdate } from '@/components/settings/profiles/useProfileUpdate';

import InputDecimal from '@/components/common/InputDecimal.vue';
import NoLineBreaks from '@/components/common/NoLineBreaks.vue';

export default {
	components: {
		Button,
		InputDecimal, NoLineBreaks,
		CheckOutlined, LoadingOutlined, EnterOutlined,
	},
	emits: ['updated'],
	props: ['record'],
	setup(props, { emit }) {
		// пришлось сделать локальное значение, потому что нельзя использовать v-model. Компилятор ругается из-за Table
		const recordRef = toRef(props, 'record');
		const connectionLimitNearVrs = ref(recordRef.value.connectionLimitNearVrs);
		watch(recordRef, value => {
			connectionLimitNearVrs.value = value.connectionLimitNearVrs;
		});
		const state = ref('default');
		const { profileUpdate } = useProfileUpdate(
			() => {
				state.value = 'loading';
			},
			() => {
				state.value = 'success';
				emit('updated');
				setTimeout(() => {
					state.value = 'default';
				}, 2000);
			},
			() => {
				state.value = 'default';
			},
		);
		const profileUpdateLocal = () => {
			profileUpdate(recordRef.value, { connectionLimitNearVrs: connectionLimitNearVrs.value });
		};
		return {
			connectionLimitNearVrs,
			state,
			profileUpdateLocal,
			successColor: Consts.COLORS.successDark,
			grayDark: Consts.COLORS.grayDark,
		};
	}
}
</script>
